import IIntegratorSettings from "../interfaces/models/IIntegratorSettings";
import Axios from "../utils/axios";

const axios = new Axios();

function messageFromAxiosError(error: any, fallback: string): string {
  const body = error?.response?.data;
  return (
    (typeof body === "string" && body.trim()) ||
    body?.message ||
    error?.message ||
    fallback
  );
}

export const getIntegratorSettings = async (): Promise<IIntegratorSettings> => {
  try {
    const response = await axios.Get("/integratorSettings");
    return response.data;
  } catch (error: any) {
    throw new Error(
      messageFromAxiosError(error, "Could not load Integrator settings.")
    );
  }
};

export const updateIntegratorSettings = async (
  settings: IIntegratorSettings
): Promise<IIntegratorSettings> => {
  try {
    const response = await axios.Put("/integratorSettings", settings);
    return response.data;
  } catch (error: any) {
    throw new Error(
      messageFromAxiosError(error, "Could not save Integrator settings.")
    );
  }
};
